// 리포트 · 조치 이력 화면 위 숫자 카드 — 필드 대시보드 카드(KpiCard)와 같은 모양(2026-10-28 오너
// "대시보드에 만들어둔 카드처럼"). 흰 바탕 · 옅은 테두리 · 이름 앞 색 아이콘 · 큰 숫자.
// 대시보드 카드는 링크지만 여기서는 누르면 목록을 그 값으로 좁히는 토글이라 button 이다.

import { useState } from 'react';
import type { IconName } from '@/components/Icon';
import { IconLabel, SHARED_BIG } from '@/pages/dashboard/_shared';

export function StatFilterCard({
  icon,
  color,
  activeBg,
  label,
  value,
  active,
  onClick,
}: {
  icon: IconName;
  /** 아이콘 · 눌린 테두리 색 */
  color: string;
  /** 눌렸을 때 바탕 */
  activeBg: string;
  label: string;
  value: number;
  active: boolean;
  onClick: () => void;
}) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        textAlign: 'left',
        padding: '8px 12px',
        borderRadius: 6,
        border: `1px solid ${active ? color : 'var(--border-card)'}`,
        background: active ? activeBg : 'var(--bg-surface)',
        boxShadow: hover ? 'var(--shadow-md)' : 'none',
        transition: 'box-shadow 0.1s ease-in-out',
        color: 'inherit',
        cursor: 'pointer',
      }}
    >
      <IconLabel icon={icon} color={color}>
        {/* 이름은 진하게(2026-10-28 오너 "글자 색 좀 진하게") — 좁은 화면에서는 말줄임. */}
        <span
          title={label}
          style={{
            color: 'var(--fg-default)',
            fontWeight: 600,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </span>
      </IconLabel>
      <div style={{ ...SHARED_BIG, fontSize: 20, lineHeight: 1.2 }}>{value}</div>
    </button>
  );
}
